/** @format */
import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import "./offerBanner.css";
import { GrClose } from "react-icons/gr";
import { Link } from "react-router-dom";
import { SiApple } from "react-icons/si";


const OfferBanner = ({ open, onClose }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    let frame;

    if (open) {
      // Schedule DOM update right before paint
      frame = requestAnimationFrame(() => {
        setAnimate(true);
      });
    } else {
      setAnimate(false);
    }

    return () => {
      if (frame) cancelAnimationFrame(frame);
    };
  }, [open]);


  // Create 24 "$50 OFF" items without manual duplication
  const discountItems = Array(24).fill("$50 OFF");

  return (
    <Drawer
      placement="bottom"
      closable={false}
      onClose={onClose}
      open={open}
      mask={false}
      height={330}
      className={`offerbanner_1 ${animate ? "open" : ""}`}
    >
      <div className="offerbanner_2">
        <div className="offerbanner_3">
          {/* Top scrolling text bar - half width */}
          <div className="offerbanner_4">
            <div className="scrolling-text">
              {discountItems.map((text, i) => (
                <h6 key={i}>{text}</h6>
              ))}
            </div>
          </div>

          {/* Center offer text */}
          <div className="offerbanner_5">
            <h5>
              Get $50 OFF your first booking
              <br />
              when you book through our app!
            </h5>
            <div className="offerbanner_6">
              <h6>Discount Code - 2VQG4IMJZ</h6>
            </div>
          </div>

          {/* Bottom scrolling text bar - half width */}
          <div className="offerbanner_7">
            <div className="scrolling-text">
              {discountItems.map((text, i) => (
                <h6 key={i}>{text}</h6>
              ))}
            </div>
          </div>
        </div>

        {/* Right side image */}
        <div className="offerbanner_8">
          <img
            src="https://shahinaimage.s3.us-west-1.amazonaws.com/shahina_1755673453586.webp"
            alt="Offer"
            width="300"
            height="300"
            fetchpriority="high"
            loading="eager"
            style={{ display: "block", objectFit: "cover" }}
          />
        </div>

        {/* App download section */}
        <div className="offerbanner_9">
          <h6>Download Our App NOW!!</h6>
          <div className="offerbanner_10">
            <Link
              to="https://play.google.com/store/apps/details?id=com.ms.shahina&hl=en-US"
              target="_blank"
            >
              <div className="offerbanner_11">
                <img
                  src="https://shahinaimage.s3.us-west-1.amazonaws.com/shahina_1755673408376.webp"
                  alt="Google Play"
                  width="35"
                  height="35"
                  loading="eager"
                />
                <div className="offerbanner_12">
                  <p>GET IT ON</p>
                  <h5>Google Play</h5>
                </div>
              </div>
            </Link>
            <Link
              to="https://apps.apple.com/in/app/shahina-med-spa/id6740401346"
              target="_blank"
            >
              <div className="offerbanner_11">
                {/* <img
                  src="https://shahinaimage.s3.us-west-1.amazonaws.com/shahina_1755673495952.webp"
                  alt="App Store"
                  width="35"
                  height="35"
                  loading="eager"
                /> */}
                <SiApple size={35} color="#fff"/>
                <div className="offerbanner_12">
                  <p>Download on the</p>
                  <h5>App Store</h5>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Close button */}
        <div className="offerbanner_13">
          <GrClose onClick={onClose} />
        </div>
      </div>
    </Drawer>
  );
};

export default OfferBanner;
